import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '../../../components/ui/Card';
import AppIcon from '../../../components/AppIcon';

const Unsubscribe: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[50vh] items-center justify-center px-4">
      <Card variant="elevated" className="w-full max-w-lg">
        <CardContent className="p-8 text-center">
          <h1 className="mb-6 text-2xl font-bold text-primary">{t('Email Unsubscribe')}</h1>
          <div role="alert" className="flex items-center gap-2 rounded-md border border-primary/30 bg-primary/10 p-3 text-sm text-primary">
            <AppIcon name="Info" size={16} />
            {t('Please contact the system administrator to unsubscribe you from emails.')}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Unsubscribe;
